module.exports = __webpack_public_path__ + "static/wiz-janowo-3_mobile-885b1ef62551a2167333b6f1f7fde9d4.jpg";